<template>
  <Navbar :title="NavbarTitle" :rightBtn="true"></Navbar>
  <div class="content-bg">
    <div class="header">
      <img class="img" src="@/assets/images/bg/bg_5@2x.png" />
      <div class="title" style="font-size: 16px">
        {{ detail.title }}
      </div>
      <div class="policy-file-item">
        <div class="policy-file-item-content">
          <div class="flex" v-if="matchType == '1'">
            <div class="flex-item">
              <div class="favorite">
                <span class="num">{{ matchingDegree }}</span>
                <span class="level">匹配评分</span>
              </div>
            </div>
            <div class="btn-boxs">
              <van-button
                class="btn-favorite btn-favorite-match"
                v-if="!detail.favorite"
                @click.stop="doFav(true)"
              >
                <img
                  class="icon-favorite"
                  src="@/assets/images/icon_favorite_1@2x.png"
                />
                收藏
              </van-button>
              <van-button
                class="btn-favorite btn-favorite-match btn-favorite-active"
                v-else
                @click.stop="doFav(false)"
              >
                <img
                  class="icon-favorite"
                  src="@/assets/images/icon_favorite_2@2x.png"
                />
                已收藏
              </van-button>
            </div>
          </div>

          <div class="flex policy-file-item-title" style="font-weight: 400">
            <div class="flex-item policy-file-item-result">
              <div class="flex-item">
                <span class="level" v-if="detail.level && detail.level > 3"
                  >其他</span
                >
                <span
                  class="level"
                  v-else-if="detail.level && detail.level == 1"
                  >省</span
                >
                <span
                  class="level"
                  v-else-if="detail.level && detail.level == 2"
                  >市</span
                >
                <span
                  class="level"
                  v-else-if="detail.level && detail.level == 3"
                  >区县</span
                >
                <span class="level" v-else>国</span>
                <span class="">阅读量:{{ detail.click_num || 0 }}</span>
              </div>
              <div class="flex-item" style="margin-left: 10px">
                收藏量:{{ detail.favorite_num || 0 }}
              </div>
            </div>
            <div class="btn-boxs" v-if="matchType != '1'">
              <van-button
                class="btn-favorite"
                v-if="!detail.favorite"
                @click.stop="doFav(true)"
              >
                <img
                  class="icon-favorite"
                  src="@/assets/images/icon_favorite_1@2x.png"
                />
                收藏
              </van-button>
              <van-button
                class="btn-favorite btn-favorite-active"
                v-else
                @click.stop="doFav(false)"
              >
                <img
                  class="icon-favorite"
                  src="@/assets/images/icon_favorite_2@2x.png"
                />
                已收藏
              </van-button>
            </div>
          </div>
          <div class="policy-file-item-tags with-row-gap">
            <span
              class="tag"
              v-for="(item, index) in detail.policyTopic"
              :key="item"
              :class="'tag_' + index"
            >
              {{ item }}
            </span>
          </div>

          <div class="policy-file-item-result" v-if="detail.dateView">
            <div class="flex-item">申报时间:{{ detail.dateView }}</div>
          </div>

          <div class="policy-file-item-result" v-else>
            <div class="flex-item" v-if="detail.startDate">
              开始时间:{{ detail.startDate }}
            </div>
            <div
              class="flex-item"
              v-if="detail.endDate"
              style="margin-left: 10px"
            >
              结束时间:{{ detail.endDate }}
            </div>
          </div>
          <div class="policy-file-item-result">
            <div class="flex-item">发文时间：{{ detail.date }}</div>
          </div>
          <div class="policy-file-item-result" v-if="detail.dispatch">
            <div class="flex-item">发文批号：{{ detail.dispatch }}</div>
          </div>
          <div class="policy-file-item-result" v-if="detail.department">
            <div class="flex-item">发文部门：{{ detail.department.name }}</div>
          </div>
          <div class="policy-file-item-result">
            <div class="flex-item">来源：{{ detail.origin }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="declare_id && detail.declare_type==0 && detail.moneyScope != 0">
      <div>
        <div class="card-title">
          <div class="flex-title-text">资金扶持</div>
        </div>
        <div class="card-content">{{ detail.moneyScope }}万元</div>
      </div>
    </div>

    <div class="tabs-box" v-if="tabs.length">
      <van-sticky :offset-top="46">
        <van-tabs
          class="tab_1"
          v-model:active="activeTabs"
          @click-tab="changeTabs"
        >
          <van-tab
            v-for="(item, index) in tabs"
            :key="item"
            :title="item.title"
            :name="item.id"
          >
          </van-tab>
        </van-tabs>
      </van-sticky>
    </div>

    <div class="tabs-content" v-if="activeTabs == 'sn_1'">
      <div class="card" v-for="item in items" :key="item.title">
        <div v-if="item.content">
          <!-- <div class="card-title">
            <div class="flex-title-text">
              {{ item.title }}
            </div>
          </div> -->
          <div class="card-content card-content-html">
            <div v-html="item.content"></div>
          </div>
        </div>
      </div>
      <div class="card" v-if="detail.url">
        <div>
          <div class="card-title">
            <div class="flex-title-text">原文链接</div>
          </div>

          <div class="card-content">
            <div>
              <a :href="detail.url" target="_blank">{{ detail.title }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="card" v-if="appendix.length">
        <div>
          <div class="card-title">
            <div class="flex-title-text">附件</div>
          </div>

          <div class="card-content">
            <div v-for="item in appendix" :key="item" class="flex" style="justify-content: space-between;">
              <a :href="item.contentView" target="_blank" class="flex-item">{{ item.name }}</a>
              <a :href="item.pathView" target="_blank" style="width:40px;display:inline-block;text-align: center;">下载</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tabs-content" v-if="activeTabs == 'sn_2'">
      <div v-if="declare_id">
        <div class="card card-table">
          <table class="table" cellspacing="0" style="position:relative;">
            <thead>
              <tr>
                <th width="55%">要求</th>
                <th width="15%">满足状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <van-popup
              show-cancel-button
              v-model:show="show"
              style="width: 80%; border-radius: 20px; height: 180px"
            >
              <div
                style="
                  padding-top: 20px;
                  line-height: 0.64rem;
                  text-align: center;
                  font-weight: bold;
                "
              >
                {{ editItem.tv }}
              </div>
              <!-- <div  style="text-align: center;color:#FE8119" v-if="editItem.g== editItem.l==editItem.e"> 申报要求资金{{editItem.g/10000}}万元 </div>
                <div  style="text-align: center;color:#FE8119" v-if="editItem.e==editItem.l&& editItem.e!=editItem.g"> 申报要求资金{{editItem.e/10000}}万元以上 </div>
                <div  style="text-align: center;color:#FE8119" v-if="editItem.l&&  !editItem.e"> 申报要求资金{{editItem.l/10000}}万元以内 </div>
                <div  style="text-align: center;color:#FE8119" v-if="editItem.l && editItem.e && editItem.l!= editItem.e"> 申报要求资金{{editItem.e/10000}}万元~{{editItem.l/10000}}万元 </div> -->
              <div class="result-box" style="padding: 20px; text-align: center">
                <van-field
                  v-model="value"
                  :placeholder="'请输入' + editItem.tv"
                  style="width: 100%; margin: 0 auto"
                  type="tel"
                />
              </div>
              <van-button
                class="van-button1"
                style="color: rgb(9, 187, 7); margin-top: 0 !important"
                @click.stop="changebtn"
                >确认</van-button
              >
            </van-popup>
            <van-popup v-model:show="show2" position="bottom">
              <van-datetime-picker
                type="date"
                title="选择时间"
                :formatter="formatter"
                @confirm="onConfirmDate"
                :min-date="minDate"
                @cancel="show2 = false"
                v-model="value"
              >
                <template #title>
                  <div style="text-align: center">{{ editItem.tv }}</div>
                </template>
              </van-datetime-picker>
            </van-popup>
            <!-- <van-popup v-model:show="show3" round :style="{ width: '80%',padding:'20px' }">
          <div class="pop-content">   
            <div>请选择博士人数情况</div>
            <van-radio-group v-model="checked" direction="horizontal">
              <van-radio name="1">1人</van-radio>
              <van-radio name="2">2人及以上</van-radio>
            </van-radio-group>
            <van-button type="success" class="pop-btn" @click.stop="changebtn"
              >确认</van-button
            >
            </div>
          </van-popup> -->
            <!-- <tbody v-if="isVip"> -->
            <tbody>
              <tr v-if="aTags.length > 0">
                <td style="text-align: left">1、行业</td>
                <td v-if="tagsType == 1">
                  <van-icon
                    class="icon"
                    name="passed"
                    size="10"
                    color="#24CAA4"
                  />
                </td>
                <td v-else>
                  <van-icon
                    class="icon"
                    name="close"
                    size="10"
                    color="#FF5019"
                  />
                </td>
                <td>
                  <span :style="{ background: tagsType == 1 ? '#24CAA4' : '#FF5019' }"  class="table-icon1" @click="changenumTags(item)"
                    >完善/更正数据</span
                  >
                </td>
              </tr>
              <tr
                v-show="isOpen"
                v-for="(item, key, index) in extend_data"
                :key="item.id"
              >
                <td width="55%" style="text-align: left">
                  <span v-if="aTags.length > 0">{{ index + 2 }}、</span>
                  <span v-else>{{ index + 1 }}、</span>
                  <span>{{ item.tv }} </span>
                  <!-- <span v-if="item.t==1">{{ item.title }} </span> -->
                  <!-- <span v-else-if="item.t!=1">{{ item.n }} </span> -->
                  <!-- <span  v-else-if="item.t==2 && item.g== item.l==item.e">{{item.n}}({{item.g/10000}}万元)  </span>
                    <span  v-else-if="item.t==2 &&item.e==item.l&& item.e!=item.g">{{item.n}}({{item.e/10000}}万元以上)  </span>
                    <span  v-else-if="item.t==2 && item.l&&  !item.e">{{item.n}}( {{item.l/10000}}万元以内)  </span>
                    <span  v-else-if="item.t==2 && item.l && item.e && item.l!= item.e">{{item.n}}({{item.e/10000}}万元~{{item.l/10000}}万元)  </span> -->
                  <!-- <span v-else> {{item.n}} </span> -->
                </td>
                <td v-if="item.type == 1" width="15%">
                  <van-icon
                    class="icon"
                    name="passed"
                    size="10"
                    color="#24CAA4"
                  />
                </td>
                <td v-if="item.type != 1" width="15%">
                  <van-icon
                    class="icon"
                    name="close"
                    size="10"
                    color="#FF5019"
                  />
                </td>
                <td>
                  <span
                    class="table-icon1"
                    :style="{ background: item.type ? '#24CAA4' : '#FF5019' }"
                    @click="changenum(item)"
                    >完善/更正数据</span
                  >
                </td>
              </tr>
              <div v-if="diagnose.total != 0">
                <button
                  class="shoubtn"
                  v-show="!isOpen && diagnose.total != 0 && aTags.length > 0"
                  @click="isOpen = !isOpen"
                >
                  查看剩余({{ diagnose.total - 1 }})条信息
                </button>
                <button
                  class="shoubtn"
                  v-show="!isOpen && diagnose.total != 0 && aTags.length == 0"
                  @click="isOpen = !isOpen"
                >
                  查看剩余({{ diagnose.total }})条信息
                </button>
                <button
                  class="shoubtn"
                  v-show="isOpen"
                  @click="isOpen = !isOpen"
                >
                  收起
                </button>
              </div>
              <div v-if="diagnose.total == 0">
                <button class="shoubtn">暂无信息</button>
              </div>
            </tbody>
            <!-- <tbody v-if="!isVip" >
              <tr v-if="aTags.length > 0">
                <td style="text-align: left">1、行业</td>
                <td v-if="tagsType == 1">
                  <van-icon
                    class="icon"
                    name="passed"
                    size="10"
                    color="#24CAA4"
                  />
                </td>
                <td v-else>
                  <van-icon
                    class="icon"
                    name="close"
                    size="10"
                    color="#FF5019"
                  />
                </td>
                <td>
                  <span :style="{ background: tagsType == 1 ? '#24CAA4' : '#FF5019' }"  class="table-icon1" @click="changenumTags(item)"
                    >完善/更正数据</span
                  >
                </td>
              </tr>
              <tr
                v-for="(item, key, index) in extend_data"
                :key="item.id"
                :class="{ 'notice-item-novip': !isVip && index == index }"
              >
                <td width="55%" style="text-align: left">
                  <span v-if="aTags.length > 0">{{ index + 2 }}、</span>
                  <span v-else>{{ index + 1 }}、</span>
                  {{ item.tv }}
                </td>
                <td v-if="item.type == 1" width="15%">
                  <van-icon
                    class="icon"
                    name="passed"
                    size="10"
                    color="#24CAA4"
                  />
                </td>
                <td v-if="item.type != 1" width="15%">
                  <van-icon
                    class="icon"
                    name="close"
                    size="10"
                    color="#FF5019"
                  />
                </td>
                <td>
                  <span
                    class="table-icon1"
                    v-if="item.type != 1"
                    @click="changenum(item)"
                    >完善/更正数据</span
                  >
                </td>
              </tr>
            </tbody>
            <div class="novip-box" v-if="!isVip &&diagnose.total!=0&&viptype!=2 ">
                <div class="flex-item">
                  <div>获取VIP后可查看</div>
                  <van-button class="btn" @click.stop="goVip"
                    >立即获取</van-button
                  >
                </div>
              </div> -->
          </table>
          <div class="diagnose">
            <div class="diagnose-t">
              <img src="@/assets/images/match/icon_6@2x.svg" />
            </div>
            <div>
              本条政策要求项共计<span class="total_1">{{ diagnose.total }}</span
              >项
            </div>
            <div>
              您已达标<span class="total_1">{{ diagnose.success }}</span
              >项，还剩<span class="total_2">{{ diagnose.fail }}</span
              >条未达标
            </div>
            <div>建议寻找第三方服务机构进行协助</div>
            <van-button class="btn" @click="doDeclare"
              >寻找服务商机构</van-button
            >
          </div>
        </div>
      </div>
      <!-- <div class="card" v-if="detail.article && detail.article.source">
        <div>
          <div class="card-title">
            <div class="flex-title-text">联系方式</div>
          </div>
          <div class="card-content">
            <span>联系人： {{ detail.contact_phone }} </span>
          </div>
        </div>
      </div> -->

      <div class="article-kv-card" v-for="item in articleKvList" :key="item">
        <div
          class="article-kv-card-title"
          style="margin: 0; padding-bottom: 0"
          v-if="item.key && item.key.replace('：', '').length > 1"
        >
          {{ item.key }}
        </div>
        <div style="margin: 0; padding: 0 0.4rem 0.4rem">
          <div class="article-kv-card-content" v-for="v in item.value" :key="v">
            <div v-if="v && v.length > 1">{{ v }}</div>
          </div>
          <div v-if="item.children && item.children.length">
            <div v-for="k in item.children" :key="k">
              <div
                style="font-weight: bold; padding: 18px 0 8px"
                v-if="k.key && k.key.replace('：', '').length > 1"
              >
                {{ k.key }}
              </div>
              <div
                class="article-kv-card-content"
                v-for="v in k.value"
                :key="v"
                style="margin: 0; line-height: 1.8"
              >
                <div v-if="v && v.length > 1">{{ v }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card similar" v-if="similar.length">
        <Similar :similar="similar"></Similar>
      </div>
    </div>
  </div>

  <div class="float-action">
    <div class="flex-item">
      <van-button class="btn" @click="doDeclare">
        <img class="icon" src="@/assets/images/match/icon_5@2x.png" />
        服务商申报
      </van-button>
    </div>
    <div class="flex-item btn-ukey-box" :data-department-id="detail.department_id" v-if="btnType != '2'">
      <van-button class="btn" @click="doDeclareKey">
        <img class="icon" src="@/assets/images/match/btn_declare@2x.png" />
        一键申报
      </van-button>
    </div>
  </div>

  <div v-if="declareShow">
    <declare-model
      :show="declareShow"
      :list="declareList"
      @declareSelected="declareSelected"
      @closeDeclare="closeDeclare"
    ></declare-model>
  </div>

  <van-popup v-model:show="showTags" round position="bottom">
    <div class="boxs">
      <p class="title" style="text-align: center; font-size: 20px">
        请选择行业
      </p>
      <div style="height: 40%; overflow: auto">
        <div class="field-ul">
          <div class="flex-tag-select-container">
            <div
              v-for="(item, i) in aTags"
              :key="i"
              class="flex-tag-select-item"
              :class="{ selected: item.checked }"
              @click.stop="() => toggleItem(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>

      <div style="margin: 0 auto; width: 100%; text-align: center">
        <van-button class="pop-btn" @click="submitTags" round type="primary"
          >确定</van-button
        >
      </div>
    </div>
  </van-popup>

  <van-popup
    v-model:show="showT19"
    round
    closeable
    class="van-dialog"
  >
      <div class="van-dialog__header" style="text-align:center;font-size:20px;">提示</div>
      <div class="van-dialog__content">
        <div class="van-dialog__message van-dialog__message--has-title">您是否{{editItem.n }}？</div>
      </div>   
    <div class="van-dialog__footer van-hairline--top">
      <van-button
        class="van-dialog__cancel"
        @click="changeT19(0)"
        round
        type="default"
        size="large"
        style="height: 48px !important; font-size: 16px; border-radius: 0"
        >否</van-button
      >
      <van-button
        class="van-dialog__confirm"
        @click="changeT19(1)"
        round
        type="default"
        size="large"
        style="height: 48px !important; font-size: 16px; border-radius: 0"
        >是</van-button
      >
    </div>
  </van-popup>

  <van-dialog
    class="service-box"
    v-model:show="showDialog"
    show-cancel-button
    :before-close="beforeClose"
  >
    <div class="title">确认服务信息</div>
    <div class="content">
      <div class="box">
        <div class="flex">
          <div class="label">服务商名称</div>
          <div class="flex-item">{{ serviceInfo.provider_name }}</div>
        </div>
        <div class="flex">
          <div class="label">服务类别</div>
          <div class="flex-item">{{ serviceInfo.type }}</div>
        </div>
      </div>
      <div class="box">
        <div class="flex">
          <div class="label">企业名称</div>
          <div class="flex-item">{{ serviceInfo.company_name }}</div>
        </div>
        <div class="flex">
          <div class="label">姓名</div>
          <div class="flex-item">{{ serviceInfo.user_name }}</div>
        </div>
        <div class="flex">
          <div class="label">手机号码</div>
          <div class="flex-item">{{ serviceInfo.phone }}</div>
        </div>
      </div>
    </div>
  </van-dialog>
</template>

<script>
import { Dialog, Notify } from "vant";
import {
  queryById,
  getUserInfo,
  queryOrderById,
  getServiceProviderList,
  addFavoritev3,
  cancelFavoritev3,
  queryFavorite,
  queryUserById,
  queryDeclareInfo,
  queryDeclareInfov3,
  queryDeclareInfov3change,
  getArticleKvV3,
  getArticleSimilarV3,
  queryDeclareInfov4,
  savePhoneAndCompanyName,
} from "@/api/home";
import moment from "moment";
import { info, cache, ws } from "@/api";
import Select from "@/components/Select.vue";
import SearchDetail from "@/components/SearchDetail.vue";
import Area from "@/components/Area.vue";
import Navbar from "@/components/Navbar";
import PolicyDetailHeader from "@/components/PolicyDetailHeader.vue";
import DeclareModel from "@/components/DeclareModel";
import { clickUrlToPhone, clickUrl, goCodeFirm  } from "@/utils/index";
import { getUserId } from "@/utils/storage";
import store from "@/store";
import Similar from "./comp/similar.vue";
import { WeixinShare } from '@/utils/wx'

export default {
  name: "ArticleDetail",
  data() {
    return {
      isOpen: false,
      detail: {
        serviceProviderTel: "",
      },
      items: [],
      show: false,
      show2: false,
      show3: false,
      list: [],
      declareShow: false,
      formCompany: {},
      showCompany: false,
      declareList: [],
      NavbarTitle: "详情",
      btnType: 0,
      favorite: false,
      queryCompany: {},
      company: {},
      value: "",
      value1: "",
      iptvalue: "500",
      matchingDegree: "",
      matchType: 0,
      activeTabs: "sn_2",
      content: 1,
      showTwoTime: true,
      formSearch: {},
      checked: 0,
      yy: 1,
      mm: 1,
      dd: 1,
      type: 2,
      aTags: [],
      tagsType: 0,
      companys: [],
      extend_data: [
        // { e: 100000, g: 100000, id: "36", l: 100000, n: "博士人数", t: 3 },
      ],
      minDate: new Date("1949/01/01"),
      tabs: [],
      articleKvList: [],
      appendix: [], //附件
      similar: [], //相似文件
      editItem: {},
      showTags: false,
      registerDate: null,
      diagnose: {
        total: 0,
        success: 0,
        fail: 0,
      },
      isVip: true,
      extendDataCompanyArr: {},
      showT19: false,
      showDialog: false,
      serviceInfo: {},
      orderInfo: {},
      viptype:1,
      favFlag: false,
      userInfo: {}
    };
  },
  components: {
    Select,
    SearchDetail,
    Area,
    Navbar,
    PolicyDetailHeader,
    DeclareModel,
    Similar,
  },
  computed: {},
  watch: {},
  mounted() {
    scrollTo(0, 0);
    this.init();
  },
  methods: {
    goVip() {
      clickUrl("/vip");
    },
    async getUserInfo() {
      try {
        let res = await queryUserById();
        this.userInfo = res.result || {};

        var share_data = {
          share: 1,
          parent_id: res.result.id,
          id: this.id,
          type: this.type,
          btnType: this.btnType,
          matchType: this.matchType,
          articleId: this.articleId,
          declare_id: this.declare_id,
          matchingDegree: this.matchingDegree
        }

        let shareData = {
          linkNow: window.location.origin + '/index.html?share_data='+ encodeURI(JSON.stringify(share_data))+"#/article/detail" ,
       } 
      //   var redirect_uri = location.href
      //   let shareData = {
      //     linkNow: encodeURIComponent(redirect_uri+'&share=1'),
      //  }  //分享链接参数
        console.log(shareData.linkNow)
        WeixinShare.create(res.result, shareData)
        
        this.getData();
        this.getDeclareList();
        console.log(this.$route.query);
        this.getArticleKv();
      
        let e_time = res.result.expiration_time
          ? res.result.expiration_time.replace(/-/g, "/")
          : null;
        let expirationTime = new Date(e_time).getTime();
        let time = new Date().getTime();
        // this.isVip = time < expirationTime ? true : false;
        this.isVip = true;
        // this.isVip = time < expirationTime ? false : true
        this.userInfo.expiration_time_show = moment(
          res.result.expiration_time
        ).format("YYYY年MM月DD日");
        console.log(this.isVip);
      } catch (res) {
        if (res.status == '2') {
          goCodeFirm(this.userInfo)
        }
        
      }

    },

    async onConfirmDate(value) {
      this.registerDate = moment(value).format("YYYY-MM-DD HH:mm:ss");
      this.changebtn();
    },
    editSucCallBack() {
      var that = this;
      this.show = false;
      this.show2 = false;
      this.showTags = false;
      that.$toast.success({ message: "提交成功", duration: 2000 });
      setTimeout(() => {
        that.extend_data = [];
        that.companys = [];
        that.value = "";
        that.getData();
      }, 2000);
    },
    changenum(item) {
      this.editItem = item;
      console.log(this.editItem);
      let e = item.t;
      this.show = false;
      if (e == 1) {
        this.value = new Date();
        this.show2 = true;
      } else if (e <= 10) {
        this.value = "";
        this.show = true;
      } else if (e > 10) {
        this.showT19 = true;
      }
    },
    changeT19(val) {
      this.editItem.e = val;
      this.changebtn();
      this.showT19 = false;
    },
    changenumTags(e) {
      this.showTags = true;
    },
    toggleItem(val) {
      val.checked = !val.checked;
    },
    async submitTags() {
      let e = this.aTags.filter((o) => o.checked).map((i) => i.id) || [];
      let tags = e.join(",");

      try {
        let res = await queryDeclareInfov4({ tags: tags });
        this.editSucCallBack();
      } catch {}
    },
    init() {
      if (this.getUrlValue('share_data')) {
        var info = JSON.parse(decodeURIComponent(this.getUrlValue('share_data')))
        this.id = info.id
        this.type = info.type
        this.btnType = info.btnType
        this.matchType = info.matchType
        this.articleId = info.articleId
        this.matchingDegree = info.matchingDegree;
        this.declare_id = info.declare_id;
      } else {

        this.id = this.$route.query.id;
        this.btnType = this.$route.query.btnType;
        this.type = this.$route.query.type || "";
        this.matchType = this.$route.query.matchType;
        this.articleId = this.$route.query.articleId;
        if (this.$route.query.matchType) {
          this.matchingDegree = this.$route.query.matchingDegree;
        }
        this.declare_id = this.$route.query.declare_id;
      }
      if (this.declare_id) {
        this.tabs = [
          { title: "申报分析", id: "sn_2" },
          { title: "政策内容", id: "sn_1" },
        ];
      } else {
        this.tabs = [
          { title: "文章解读", id: "sn_2" },
          { title: "文章内容", id: "sn_1" },
        ];
      }
      this.getUserInfo();
      
    },
    async doFav(type) {
      if(this.favFlag){
        return false
      }
      this.favFlag = true
      let request = type ? addFavoritev3 : cancelFavoritev3;
      let res = await request({ article_id: this.articleId });
      this.$toast.success({
        message: type ? "收藏成功" : "取消收藏成功",
        duration: 2000,
      });
      setTimeout(() => {
        this.getData();
      }, 2000);
    },
    async changebtn() {
      // if ((this.editItem.t == "2" || (this.editItem.t == "3" && this.editItem.id == "36")) && !this.value.length) {
      if (
        this.editItem.t != "1" &&
        this.editItem.t <= "10" &&
        !this.value.length
      ) {
        this.show = true;
        this.$toast("请输入" + this.editItem.n);
        return false;
      }
      let obj = this.editItem;
      if (this.editItem.t == "1") {
        //时间
        obj.e = this.registerDate;
      } else if (this.editItem.t == "2") {
        //营收
        obj.e = this.value * 10000;
        // } else if (this.editItem.t == "3" && this.editItem.id == "36") {
      } else if (this.editItem.t <= "10") {
        obj.e = this.value;
        // } else if(this.editItem.t == "19") {
      } else if (this.editItem.t > "10") {
        obj.e = this.editItem.e;
      }

      let params = Object.assign({}, this.extendDataCompanyArr);
      params[this.editItem.id] = obj;

      try {
        let res = await queryDeclareInfov3change({
          extend_data: JSON.stringify(params),
        });
        if(this.value % 1 !== 0 &&this.editItem.t != "2"){
            this.$toast.success({
            message:  "请输入整数值",
            duration: 2000,
          });
      this.show = false;
      this.show2 = false;
      this.showTags = false;
      }else{
        this.editSucCallBack();
      }
      } catch {
        this.show = false;
      }
    },
    async getData() {
      let res = await queryDeclareInfo({
        id: this.articleId,
      });
      let detail = res.result;
      if (res.result.title) {
        this.getArticleSimilar(res.result.title);
      }
      this.getMatch(res);
      this.getDeclareInfo(res);
      detail.date = res.result.time
        ? moment(res.result.time).format("YYYY-MM-DD")
        : "";

      let nowTime = new Date().getTime();
      let startTime =
        res.result.declare && res.result.declare.start_time
          ? moment(res.result.declare.start_time).toDate().getTime()
          : "";
      let endTime =
        res.result.declare && res.result.declare.end_time
          ? moment(res.result.declare.end_time).toDate().getTime()
          : "";
      detail.startDate =
        res.result.declare && res.result.declare.start_time
          ? moment(res.result.declare.start_time).format("YYYY-MM-DD")
          : "";
      detail.endDate =
        res.result.declare && res.result.declare.end_time
          ? moment(res.result.declare.end_time).format("YYYY-MM-DD")
          : "";

      if (startTime && endTime && startTime == endTime) {
        detail.dateView = detail.startDate;
      }

      this.favorite = res.result.favorite ? true : false;

      detail.moneyScope = "";
      let  moneyScopeMax =
        res.result.declare && res.result.declare.money_scope_max
          ? Math.floor(res.result.declare.money_scope_max) / 10000
          : 0;
      let moneyScopeMin =
        res.result.declare && res.result.declare.money_scope_min
          ? Math.floor(res.result.declare.money_scope_min) / 10000
          : 0;

      if (moneyScopeMin == moneyScopeMax) {
        detail.moneyScope += moneyScopeMin;
      } else {
        detail.moneyScope += moneyScopeMin + "-" + moneyScopeMax;
      }

      this.detail = detail;
      this.favFlag = false
    },
    getBaseInfo(res) {},
    getDeclareInfo(res) {
      this.items = [
        { title: " ", content: res.result.content },
        // { title: '扶持条件', content: res.result.article.support_conditions },
        // { title: '申报材料', content: res.result.article.filing_materials },
        // { title: '申报流程', content: res.result.article.declaration_process },
        // { title: '联系方式', content: res.result.article.contact_phone },
        // { title: '政策文件', content: res.data.dispatchDepartment }
      ];
      //附件
      this.appendix = res.result.appendix.map((o) => {
        return {
          ...o,
          contentView: location.origin + "/" + o.content,
          pathView: location.origin + "/" + o.path,
        };
      });
    },
    getMatch(res) {
      let extendDataArr = JSON.parse(res.result.extend_data) || {};
      if(JSON.stringify(extendDataArr)==="{}"){
          this.viptype=2
      }
      let extendDataCompanyArr =
        JSON.parse(res.result.company.extend_data) || {};
      let count = 0,
        total = 0;
      for (var i in extendDataArr) {
        let ed = extendDataArr[i];
        ed.type = extendDataCompanyArr[i] ? extendDataCompanyArr[i].e : 0;
        ed.tv = ed.n;
        // console.log(i,extendDataCompanyArr[i]);

        if (ed.t == "1") {
          ed.type = 0;
          //时间
          if (extendDataCompanyArr[i]) {
            let _tg = ed.g ? moment(ed.g).toDate().getTime() : "";
            let _tl = ed.l ? moment(ed.l).toDate().getTime() : "";
            let _stg = extendDataCompanyArr[i].e
              ? moment(extendDataCompanyArr[i].e).toDate().getTime()
              : "";
            if (_stg) {
              if (
                (!_tg && _tl && _stg < _tl) ||
                (_tg && !_tl && _stg > _tg) ||
                (_tg && _tl && _tg < _stg && _stg < _tl)
              ) {
                ed.type = 1;
              } else {
                ed.type = 0;
              }
            } else {
              ed.type = 0;
            }
          }
          ed.tv = ed.n;
          let _tg_m = ed.g ? moment(ed.g).format("YYYY-MM-DD") : "";
          let _tl_m = ed.l ? moment(ed.l).format("YYYY-MM-DD") : "";
          if (_tg_m && _tl_m) {
            ed.tv += `(${_tg_m}~${_tl_m})`;
          } else if (_tg_m) {
            ed.tv += `(大于${_tg_m})`;
          } else if (_tl_m) {
            ed.tv += `(小于${_tl_m})`;
          }
        } else if (ed.t <= "10") {
          let ee =
            extendDataCompanyArr[i] && extendDataCompanyArr[i].e
              ? extendDataCompanyArr[i].e
              : 0;
          let obj = this.getRangeLess10(ed, ee);
          ed.type = obj.type;
          ed.tv = obj.title;
        }

        if (ed.type == "1") {
          count++;
        }
        total++;
      }
        // if (!this.isVip) {
        // var newData = {}
        // var newDatas={}
        // let newKeys = Object.keys(extendDataArr)
        // newKeys.map((item,idx)=>{
        //     if(idx < 2){
        //     newData[item] = extendDataArr[item]
        //     }
        // })
        // for (let key in newData){
        //     let newKey = key.substring(0,2)
        //     newDatas[newKey] = newData[key]
        // }
        // this.extend_data = newDatas;
        // console.log(this.extend_data);
        //   // this.extend_data = extendDataArr.substring(0,2)
        //   // console.log(this.extend_data.length);

        // }else{

        //   this.extend_data = extendDataArr;
        // }
      this.extend_data = extendDataArr;

      let aTags = res.result.aTags ? res.result.aTags : [];
      if (aTags.length) {
        total++;
      }
      let _tag = res.result.company.tags
        ? res.result.company.tags.split(",")
        : [];
      var arr = aTags.filter((o) => _tag.includes(o.id.toString())) || [];
      this.tagsType = 0;
      if (arr.length) {
        this.tagsType = 1;
        count++;
      }

      this.aTags = aTags.map((item) => {
        return {
          ...item,
          checked: _tag.includes(item.id.toString()),
        };
      });
      this.companys = _tag;
      this.diagnose = {
        total: total,
        success: count,
        fail: total - count,
      };
      this.extendDataCompanyArr = extendDataCompanyArr;

      console.log("extend_data=>", this.extend_data.length==undefined);
      console.log("extendDataCompanyArr=>", extendDataCompanyArr);
    },
    getRangeLess10(ed, ee) {
      let obj = {
        type: 0,
        title: `${ed.n}`,
      };

      if (
        ed.e &&
        ((!ed.g && !ed.l) || (ed.l && ed.g && (ed.g == ed.l) == ed.e))
      ) {
        obj.type = ee < ed.e ? 1 : 0;

        if (ed.t == 2) {
          obj.title += `(${ed.e / 10000}万元以内)`;
        } else if (ed.t == 3) {
          obj.title += `(${ed.e}人以内)`;
        } else {
          obj.title += `(${ed.e}以内)`;
        }
      } else if (ed.g && !ed.l) {
        obj.type = ee >= ed.g ? 1 : 0;

        if (ed.t == 2) {
          obj.title += `(${ed.g / 10000}万元以上)`;
        } else if (ed.t == 3) {
          obj.title += `(${ed.g}人以上)`;
        } else {
          obj.title += `(${ed.g}以上)`;
        }
      } else if (!ed.g && ed.l) {
        obj.type = ee < ed.l ? 1 : 0;

        if (ed.t == 2) {
          obj.title += `(${ed.l / 10000}万元以内)`;
        } else if (ed.t == 3) {
          obj.title += `(${ed.l}人以内)`;
        } else {
          obj.title += `(${ed.l}以内)`;
        }
      } else if (ed.g && ed.l) {
        obj.type = ed.g <= ee && ed.l > ee ? 1 : 0;

        if (ed.t == 2) {
          obj.title += `(${ed.g / 10000}万元~${ed.l / 10000}万元)`;
        } else if (ed.t == 3) {
          obj.title += `(${ed.g}~${ed.l}人)`;
        } else {
          obj.title += `(${ed.g}~${ed.l})`;
        }
      }
      return obj;
    },
    getNum(str) {
      let num = 0;
      if (str) {
        num = parseFloat(str * 100).toFixed(2);
      }
      return num;
    },
    async getDeclareList() {
      let res = await getServiceProviderList();
      this.declareList = res.result.data || [];
    },
    doDeclare() {
      if (!this.userInfo.company || (this.userInfo.company && !this.userInfo.company.name) ||this.userInfo.certification_flag==0) {
        // this.$dialog.alert({
        //   message: '请先前往个人中心关联企业',
        // }).then(() => {

        // })
        clickUrl('/enterprise_match')
        return false
      }
      this.declareShow = true;
    },
    declareSelected(arg) {
      this.declareShow = false;
      this.serviceInfo = {
        provider_name: arg.name,
        provider_id: arg.id,
        company_name: this.userInfo.company.name,
        phone: this.userInfo.phone,
        declare_id: this.articleId,
        user_name: this.userInfo.name,
        type: this.declare_id ? '政策申报' : ''
      };
      this.showDialog = true;
      // let query = {
      //   type: "getPhone",
      //   declare_id: this.articleId,
      //   serviceProviderId: arg.id,
      // };
      // clickUrlToPhone("", query);
    },
    closeDeclare() {
      this.declareShow = false;
    },
    changeTabs(val) {
      this.activeTabs = val.name;
      console.log(this.activeTabs);
    },
    getUrlValue(kValue) {
      var url = window.location.href;  //当前页面的地址
      var reg = /([^?&=]+)=([^?&=]+)/g, obj = {}, str = url;
      url.replace(reg, function () {
        obj[arguments[1]] = arguments[2];
      })
      for (var keyName in obj) {
        if (keyName == kValue) {
          let val = obj[keyName]
          if (val.indexOf("#") > 0) {
            val = val.substring(0, val.indexOf("#"))
          }
          return val;
        }
      }
    },
    async doDeclareKey() {
      var that = this;
      try {
        let res = await queryUserById();
        let e_time = res.result.expiration_time
          ? res.result.expiration_time.replace(/-/g, "/")
          : null;
        let expirationTime = new Date(e_time).getTime();
        let time = new Date().getTime();
        // let isVip = time < expirationTime ? true : false;
        let isVip = true;

        if (that.getUrlValue('type') == 'ukey') {
          return false
        }
        that.$dialog
          .confirm({
            message: isVip
              ? "请使用u-Key在PC端进行申报"
              : "该功能仅限VIP用户使用\n如需自主申报请开通VIP",
            showCancelButton: !isVip ? true : false,
            confirmButtonText: !isVip ? "去开通" : "确认",
          })
          .then(() => {
            if (!isVip) {
              clickUrl("/vip");
            }
          })
          .catch(() => {});
      } catch {}
    },
    async getArticleKv() {
      try {
        let res = await getArticleKvV3({
          id: this.articleId,
        });
        this.articleKvList = this.getArticleKvList(res.result, []);
      } catch {}
    },
    getArticleKvList(data, arr) {
      for (var i in data) {
        let obj = {
          key: data[i].key,
          children: [],
          value: data[i].value,
        };
        if (data[i].children) {
          this.getArticleKvList(data[i].children, obj.children);
        }
        arr.push(obj);
      }
      return arr;
    },
    async getArticleSimilar(title) {
      try {
        let res = await getArticleSimilarV3({ title: title });
        this.similar = res.result || [];
      } catch {}
    },
    doDeclareV3() {
      this.showDialog = true;
    },
    cancelService() {
      this.showDialog = false;
    },
    async beforeClose(action, done) {
      var that = this;
      if (action === "confirm") {
        // 点击确定走这里
        that.confirmService(function () {
          that.showDialog = false;
          that.$toast.success({ message: "提交成功" });
          that.checkXcx();
        });
      } else {
        // 点击取消走这里
        this.showDialog = false;
      }
    },
    async confirmService(callback) {
      let params = Object.assign({}, this.serviceInfo);
      try {
        let res = await savePhoneAndCompanyName(params);
        this.orderInfo = res.result;
        if (callback) {
          callback();
        }
      } catch {}
    },
    checkXcx() {
      var u = navigator.userAgent;
      if (u.indexOf("miniProgram") !== -1) {
        //在小程序里
        return false;
      }
      // 在微信网页
      this.$router.replace({
        path: "/order/detail",
        query: { id: this.orderInfo },
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    // 离开的时候，非以下页面则删除缓存组件 name
    // 记录路由处的name值
    let coms = ["PolicyQuery", "EnterpriseMatch", "Empty"];
    console.log(coms.indexOf(to.name) === -1, to.name);
    if (coms.indexOf(to.name) === -1) {
      for (var i in coms) {
        store.commit("REMOVE_KEEP_ALIVE_COM", coms[i]);
      }
    }
    next();
  },
};
</script>

<style lang="scss" scoped>
.content-bg {
  padding: 0 0 80px;
}
.header {
  .img {
    top: 0;
    z-index: -1;
    height: 85%;
  }
  .title {
    color: #fff;
    font-size: 32px;
    font-weight: 600;
    margin: 30px 25px 15px;
    display: flex;
    align-items: center;
  }
  .origin {
    margin: 3px 10px 5px;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 14px;
    -webkit-background-clip: text;
  }
  .policy-file-item {
    margin: 0 20px;
  }
}
.card {
  width: auto;
  margin: 0 10px 12px;
  background: #fff;
  border-radius: 8px;
  > div {
    padding: 10px 15px;
  }
  .card-title {
    margin: 0;
    font-size: 14px;
    &:before {
      border-left: 4px solid #0c9de9;
    }
    &:first-of-type {
      border: 0;
    }
  }
  .card-content {
    margin: 10px 0 0;
    padding: 0;
    color: #666;
  }
}
.policy-file-item {
  box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  margin: 20px 0 12px;

  .level {
    width: 20px;
    padding: 1px;
    background: #1989fa;
    color: #fff;
    border-radius: 4px;
    font-weight: 400;
    margin-right: 5px;
  }
  .level-right {
    margin-left: 40%;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #555555;
    line-height: 14px;
  }

  .tag {
    padding: 0 3px;
    color: #000;
    border-radius: 4px;
    font-weight: 400;
    margin-right: 5px;

    &.tag_0 {
      background: #d8f4f0;
      border: 1px solid #33978b;
    }

    &.tag_1 {
      background: rgba(139, 184, 213, 0.35);
      border: 1px solid #8bb8d5;
    }
  }
}
.policy-file-item-result {
  display: flex;
  justify-content: space-between;
  color: #999;
  line-height: 20px;

  .result-f {
    color: #fff;
    background: #ff642e;
    padding: 2px 3px;
    border-radius: 4px;
    line-height: 15px;
  }
}

.color-1 {
  color: #ff642e;
}
.num {
  font-size: 48px;
  font-weight: 600;
  color: #ff642e;
}
.source {
  color: #fff;
  margin: 3px 0 5px;
}

.tabs-box {
  margin: 0 16px;
}
.tabs-content {
  margin-bottom: 12px;
}
::v-deep .van-tabs__nav {
  background: #e7e7e7;
  border-radius: 8px;
  .van-tab {
    font-size: 14px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.4);
    line-height: 16px;
    &--active {
      background: #fff;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      .van-tab__text {
        color: rgba(0, 0, 0, 0.8) !important;
      }
    }
  }
}

.card-table {
  padding: 10px 6px 20px;
}
.table {
  width: 100%;
  background: #fff;
  .table-icon1 {
    background: #24caa4;
    border-radius: 2px 2px 2px 2px;
    opacity: 1;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 14px;
    margin-right: 4px;
    padding: 1px;
  }
  .table-icon2 {
    background: #24caa4;
    border-radius: 2px 2px 2px 2px;
    opacity: 1;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 14px;
    padding: 1px;
  }
}
th {
  background: rgba(207, 236, 255, 0.6);
}
td,
th {
  height: 40px;
  text-align: center;
}
tbody td {
  border-bottom: 1px solid rgba(207, 236, 255, 0.5);
  .icon {
    margin-right: 3px;
    vertical-align: middle;
  }
}

.float-action {
  height: auto;
  .flex-item {
    display: flex;
    align-items: center;
    .btn {
      border-radius: 20px;
      height: 42px !important;
      line-height: 43px;
      color: #fff;
      border: 1px solid transparent;
      margin: 5px 0 10px !important;
      .icon {
        width: 20px;
        height: 20px;
        vertical-align: middle;
        background-size: 100% 100%;
      }
    }
  }
}

.btn-ukey-box {
  margin-left: 5px;
  .btn {
    background: linear-gradient(
      94deg,
      #24caa4 0%,
      #1fbc98 100%,
      rgba(36, 202, 164, 0) 100%
    );
  }
}
::v-deep .tab_1 {
  .van-tab:first-of-type {
    &.van-tab--active::after {
      position: absolute;
      content: "";
      width: 8px;
      height: 8px;
      line-height: 10px;
      display: block;
      text-align: center;
      background-image: radial-gradient(20px at 8px 0px, #e7e7e7 8px, #fff 8px);
      bottom: 0px;
      right: -8px;
    }
  }

  .van-tab:nth-last-of-type(2) {
    &.van-tab--active::after {
      position: absolute;
      content: "";
      width: 8px;
      height: 8px;
      line-height: 8px;
      display: block;
      text-align: center;
      background-image: radial-gradient(20px at 0px 0px, #e7e7e7 8px, #fff 8px);
      bottom: 0;
      left: -8px;
    }
  }
}
.title-icon {
  width: 100%;
  height: 40px;
  display: flex;
  flex-wrap: wrap;
}
.title-icon1 {
  padding: px;
  height: 15px;
  background: #d8f4f0;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #33978b;
  font-size: 10px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 12px;
  margin-right: 4px;
}
.title-icon2 {
  font-size: 10px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 12px;
  height: 15px;
  background: rgba(139, 184, 213, 0.35);
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #8bb8d5;
}
.popup {
  width: 200px !important;
  height: 120px !important;
}
/* .van-button--success {
  margin-left: 40%;
  margin-top: 80px;
} */
.origin {
  color: #fff;
  font-size: 12px;
  margin: 0.08rem 0.66667rem 0.13333rem !important;
}
.result-box {
  .van-cell {
    //   top: 10%;
    //   left: 12%;
    //   width: 250px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid rgba(35, 199, 162, 0.2);
  }
}
.van-button1 {
  height: 40px !important;
  width: 100% !important;
  margin-top: 60px !important;
  border: none;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 20px !important;
}

.article-kv-card {
  width: auto;
  margin: 0 10px 12px;
  background: #fff;
  border-radius: 8px;
  > div {
    padding: 10px 15px;
  }
  .article-kv-card-title {
    margin: 0;
    font-size: 14px;
    &:before {
      content: "";
      height: 16px;
      margin-right: 5px;
      border-left: 4px solid #0c9de9;
    }
    &:first-of-type {
      border: 0;
    }
  }
  .article-kv-card-content {
    margin: 10px 0 0;
    padding: 0;
    color: #666;
  }
}
.van-popup--center {
  width: 200px !important;
  height: 100px !important;
  border-radius: 5px;
}

.field-ul {
  margin: 0 20px;
  display: flex;
  flex-wrap: wrap;
}

.flex-tag-select-container {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  box-sizing: border-box;
  z-index: 10;
  overflow: auto;
}

.flex-tag-select-item {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #252525;
  min-height: 40px;
  border: 1px solid #ddd;
  // padding: 0 16px;
  box-sizing: border-box;
  background: #fff;
}

.flex-tag-select-item.selected {
  border: 1px solid #1b53b9;
  color: #1b53b9;
  background: #ebf3fa;
}
.pop-content {
  width: 100%;
  text-align: center;
}
.pop-btn {
  text-align: center;
  margin: 20px auto;
  width: 58%;
  height: 45px !important;
  background: linear-gradient(129deg, #1091e8 0%, #1a6fe0 100%);
  img {
    width: 20px;
    height: 19px;
    background-size: cover;
    vertical-align: middle;
    margin-right: 6px;
  }
}
.diagnose {
  background: url("../../assets/images/match/diagnose@2x.svg") no-repeat center
    center;
  background-size: 100%;
  padding: 12px 30px;
  margin-top: 30px;
  border-radius: 20px;
  color: #fff;
  text-align: center;
  font-size: 14px;
  line-height: 27px;
  .diagnose-t {
    img {
      width: 80%;
      margin: auto;
      background-size: contain;
    }
  }
  .btn {
    width: 141px;
    height: 40px !important;
    line-height: 40px;
    background: linear-gradient(
      94deg,
      #24caa4 0%,
      #1fbc98 100%,
      rgba(36, 202, 164, 0) 100%
    );
    box-shadow: 0px 4px 6px 1px rgba(16, 110, 177, 0.5);
    border-radius: 20px;
    border: 1px solid #fff;
    color: #fff;
    margin: 30px auto;
  }
  .total_1 {
    color: #ffff00;
  }
  .total_2 {
    color: #ff9d2b;
  }
}

.btn-boxs {
  width: 73px;
  height: 30px;
  margin-left: 12px;
  .btn-favorite {
    width: 100%;
    height: 30px;
    line-height: 35px;
    background: #24caa4;
    border: 1px solid transparent;
    color: #fff;
    border-radius: 30px;
    padding: 0 !important;
    text-align: center;
    &-match {
      margin-top: 15px;
    }
    .icon-favorite {
      height: 15px;
      background-size: cover;
      vertical-align: middle;
      margin-top: -4px;
    }
    &-active {
      background: linear-gradient(90deg, #ff7019 0%, #fe8f1a 100%);
    }
    &-dis {
      background: rgba(85, 138, 126, 0.2);
    }
  }
}
.notice-item-novip {
  filter: blur(4px);
  .notice-item-title {
    color: rgba(0, 0, 0, 0.2);
  }
}
.shoubtn {
  width: 128px;
  min-height: 25px;
  padding: 4px;
  background: #ffffff;
  border-radius: 22px 22px 22px 22px;
  opacity: 1;
  border: 1px solid #24caa4;
  font-size: 12px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #24caa4;
  line-height: 14px;
  margin-left: 55%;
  margin-top: 20px;
}
.novip-box {
  position: absolute;
  z-index: 5;
  display: flex;
  align-items: center;
  text-align: center;
  top:60%;
  left: 0;
  width: 100%;
  font-size: 12px;
  color: #666;
  .flex-item {
    flex: 1;
    .btn {
      width: 105px;
      height: 35px !important;
      line-height: 30px;
      background: linear-gradient(180deg, #fff4e0 0%, #fbcb89 100%);
      box-shadow: 0px 4px 4px 1px rgba(180, 164, 123, 0.25);
      border-radius: 20px;
      border: 0;
      font-size: 12px;
      font-weight: 600;
      color: #ff5019;
      white-space: nowrap;
      margin-top: 5px;
    }
  }
}
.novip-box1 {
  position: absolute;
  z-index: 5;
  display: flex;
  align-items: center;
  text-align: center;
  top: 40px;
  left: 0;
  width: 100%;
  /* height: 100%; */
  font-size: 12px;
  color: #666;
  .flex-item {
    flex: 1;
    .btn {
      width: 105px;
      height: 35px !important;
      line-height: 30px;
      background: linear-gradient(180deg, #fff4e0 0%, #fbcb89 100%);
      box-shadow: 0px 4px 4px 1px rgba(180, 164, 123, 0.25);
      border-radius: 20px;
      border: 0;
      font-size: 12px;
      font-weight: 600;
      color: #ff5019;
      white-space: nowrap;
      margin-top: 5px;
    }
  }
}
.service-box {
  .title {
    height: 42px;
    line-height: 42px;
    background: linear-gradient(360deg, #18a0ff 0%, #0bc6fc 100%);
    font-size: 18px;
    font-weight: 500;
    color: #fff;
    text-align: center;
  }
  .content {
    padding: 20px 13px;
    .box {
      border-top: 1px solid #f7f7f7;
      &:first-child {
        margin-bottom: 20px;
      }
      .flex {
        font-size: 12px;
        font-weight: 400;
        color: #999;
        border-bottom: 1px solid #f7f7f7;
        padding: 6px 0;
        .label {
          width: 83px;
          color: #666;
          text-align: center;
          border-right: 1px solid #f7f7f7;
          margin-right: 10px;
        }
      }
    }
  }
}
.card-content-html {
  table {
    width: 100% !important;
    overflow-x: auto;
  }
}
</style>
<style lang="scss">
.similar .card-title {
  padding: 10px 15px 0;
}
.service-box {
  .van-dialog__cancel {
    height: 41px !important;
    background: rgba(117, 169, 189, 0.2);
    font-size: 16px;
    font-weight: 400;
    color: #7c7c7c;
  }
  .van-dialog__confirm {
    height: 41px !important;
    background: #1a8af1;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
  }
}
</style>
